import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "Filter", -1)
const _hoisted_3 = { class: "d-flex justify-space-evenly" }
const _hoisted_4 = {
  class: "mt-2",
  align: "center"
}
const _hoisted_5 = {
  class: "mt-2",
  align: "center"
}

import { computed, ref } from "vue"
import { onMounted } from "vue"
import { commonStore } from "@/stores/common-store"
import { SPECIALIZATION_DATA_DE, SPECIALIZATION_DATA_EN } from "@/types/spec"
import { Department, Hospital } from "@/types"

interface SearchFilterDoc {
  includeHospital: boolean
  includeClinic: boolean
  hospitalValue: string | null
  departmentValue: string | null
  clinic: string | null
  reset: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterComponent',
  props: {
  type: {
    type: String,
  },
  openMenu: {
    type: Boolean,
  },
  specialty: {
    type: String,
  },
  hospitalId: {
    type: String,
  },
  department: {
    type: String,
  },
},
  emits: ["filter-applied", "close"],
  setup(__props, { emit: __emit }) {

const emit = __emit
const props = __props

const includeHospital = ref(false)
const includeClinic = ref(false)
const publicStore = commonStore()
const hospitals = ref()
const showFilterDialog = ref(false)
const chosenHospital = ref<string | null>(null)
const chosenDepartment = ref<string | null>(null)
const chosenSpecialty = ref<string | null>(null)
const locale = ref(localStorage.getItem("locale") ?? "de")
const filterTabs = ref<string | null>(null)

const departments = ref<Department[]>([])

onMounted(async () => {
  if (props.type) {
    filterTabs.value = props.type
  }

  await getHospitals()
  await loadHospitalDepartments()
  loadFilters()
})

const filterNumbers = computed((): number => {
  var numberOfFilters = 0
  if (props.type == "hospitalAttached") {
    numberOfFilters++
    if (props.hospitalId) {
      numberOfFilters++
    }
    if (props.department) {
      numberOfFilters++
    }
  } else if (props.type == "privateClinic") {
    numberOfFilters++
    if (props.specialty) {
      numberOfFilters++
    }
  }
  return numberOfFilters
})

const getDepartmentName = computed(() => (department: Department): string => {
  return locale.value == "de" ? department.de : department.en
})
const getDepartmentValue = (department: Department): string => {
  return department.value
}

const loadFilters = () => {
  if (props.type == "privateClinic" && props.specialty) {
    chosenSpecialty.value = props.specialty
  } else if (props.type == "hospitalAttached") {
    if (props.hospitalId) {
      chosenHospital.value = props.hospitalId
    }
    if (props.department) {
      chosenDepartment.value = props.department
    }
  }
}

const loadHospitalDepartments = async (): Promise<void> => {
  const response = await publicStore.getDepartments()
  if (response.success) {
    departments.value = response.result as Department[]
  }
}

const applyFilter = async () => {
  if (filterTabs.value == "privateClinic") {
    includeClinic.value = true
  } else if (filterTabs.value == "hospitalAttached") {
    includeHospital.value = true
  }
  const searchFilter: SearchFilterDoc = {
    includeHospital: includeHospital.value,
    includeClinic: includeClinic.value,
    hospitalValue: chosenHospital.value,
    departmentValue: chosenDepartment.value,
    clinic: chosenSpecialty.value,
    reset: false,
  }
  emit("filter-applied", searchFilter)
  includeHospital.value = false
  includeClinic.value = false

  showFilterDialog.value = false
}

const resetFilter = async () => {
  const searchFilter: SearchFilterDoc = {
    includeHospital: false,
    includeClinic: false,
    hospitalValue: null,
    departmentValue: null,
    clinic: null,
    reset: true,
  }

  emit("filter-applied", searchFilter)
  showFilterDialog.value = false
}
onMounted(async () => {
  window.addEventListener("locale-changed", updateLocale)
  window.addEventListener("locale-changed", loadFilters)
})

const updateLocale = () => {
  locale.value = localStorage.getItem("locale") ?? "de"
}

const getHospitalName = (hospital: any): string => {
  return hospital.name
}

const getHospitals = async (): Promise<void> => {
  const response = await publicStore.getAllHospitals()
  if (response.success) {
    hospitals.value = response.result
  }
}

const getHospitalValue = (hospital: any): string => {
  return hospital._id
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (filterNumbers.value)
      ? (_openBlock(), _createBlock(_component_v_badge, {
          key: 0,
          content: filterNumbers.value,
          color: "#25344d",
          class: "ml-5 mr-5 mt-2 mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              icon: "mdi-filter-variant",
              color: "#3fb984",
              size: "small",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showFilterDialog.value = true))
            })
          ]),
          _: 1
        }, 8, ["content"]))
      : (_openBlock(), _createBlock(_component_v_btn, {
          key: 1,
          class: "ml-5 mr-5 mt-2 mb-5",
          icon: "mdi-filter-variant",
          color: "#3fb984",
          size: "small",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showFilterDialog.value = true))
        })),
    _createVNode(_component_v_dialog, {
      "max-width": "500",
      modelValue: showFilterDialog.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showFilterDialog).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex justify-space-between mb-5" }, {
              default: _withCtx(() => [
                _hoisted_1,
                _hoisted_2,
                _createVNode(_component_v_btn, {
                  icon: "mdi-close",
                  variant: "text",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (showFilterDialog.value = false))
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_tabs, {
                modelValue: filterTabs.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filterTabs).value = $event)),
                "show-arrows": "",
                "bg-color": "#25344d",
                "fixed-tabs": "",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tab, { value: "privateClinic" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("clinics")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tab, { value: "hospitalAttached" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("hospitals")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createVNode(_component_v_window, {
              modelValue: filterTabs.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filterTabs).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window_item, { value: "privateClinic" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_v_autocomplete, {
                        class: "ml-4 mr-4",
                        "prepend-inner-icon": "mdi-doctor",
                        modelValue: chosenSpecialty.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((chosenSpecialty).value = $event)),
                        items: 
                locale.value == 'de' ? _unref(SPECIALIZATION_DATA_DE) : _unref(SPECIALIZATION_DATA_EN)
              ,
                        label: _ctx.$t('search.specialty'),
                        outlined: "",
                        "menu-props": { width: '700px' },
                        style: {"min-width":"250px"}
                      }, null, 8, ["modelValue", "items", "label"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "hospitalAttached" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_v_autocomplete, {
                        modelValue: chosenHospital.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((chosenHospital).value = $event)),
                        label: "Hospitals",
                        items: hospitals.value,
                        "item-title": getHospitalName,
                        "item-value": getHospitalValue,
                        style: {"width":"90%"}
                      }, {
                        item: _withCtx(({ props, item }) => [
                          _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                            subtitle: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.raw.hospitalLocation) + ", " + _toDisplayString(item.raw.hospitalLand), 1)
                            ]),
                            _: 2
                          }, 1040)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "items"]),
                      _createVNode(_component_v_autocomplete, {
                        modelValue: chosenDepartment.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((chosenDepartment).value = $event)),
                        label: "Abteilung",
                        items: departments.value,
                        "item-title": getDepartmentName.value,
                        "item-value": getDepartmentValue,
                        style: {"width":"90%"}
                      }, null, 8, ["modelValue", "items", "item-title"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "mr-2",
                  onClick: resetFilter
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Reset")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "#3fb984",
                  variant: "flat",
                  onClick: applyFilter
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Apply")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})